import { isChunkLoadError } from './chunkLoadError'

type SentryExceptionValue = {
  type?: string
  value?: string
}

type SentryLikeEvent = {
  message?: string
  exception?: {
    values?: SentryExceptionValue[]
  }
}

const NOISE_PATTERNS = [
  /(^|:\s*)network error$/i,
  /resizeobserver loop/i,
  /ignored attempt to cancel a touch/i,
  /the play method is not allowed by the user agent/i,
  /play\(\) failed because the user didn't interact/i,
  /non-error promise rejection captured with value:\s*undefined/i
]

export function sentryEventTexts (event: SentryLikeEvent): string[] {
  const texts: string[] = []
  if (event.message) {
    texts.push(event.message)
  }
  for (const item of event.exception?.values || []) {
    if (item.type) {
      texts.push(item.type)
    }
    if (item.value) {
      texts.push(item.value)
    }
  }
  return texts
}

export function isExpectedClientNoise (event: SentryLikeEvent): boolean {
  const texts = sentryEventTexts(event)
  if (texts.some(text => isChunkLoadError(text))) {
    return true
  }
  return texts.some(text => NOISE_PATTERNS.some(pattern => pattern.test(text.trim())))
}
